export const LANG_DE = "de";
export const LANG_SK = "sk";

export let translations = {};

export function createMarkerIcon() {
	return new window["L"].Icon({
		iconUrl: "/images/marker-icon-2x.png",
		iconRetinaUrl: "/images/marker-icon-2x.png",
		iconSize: [25, 41],
		iconAnchor: [12, 41],
		popupAnchor: [1, -34],
		tooltipAnchor: [16, -28],
	});
}

export function setTranslations(t) {
	translations = t;
}

export function t(x) {
	return translations[x] || x;
}

export function randomInt(min, max) {
	return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function fileToBase64(file) {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = () => resolve(reader.result);
		reader.onerror = reject;
		reader.readAsDataURL(file);
	});
}

export function getLanguage() {
	if (window.location.search.includes("lang=de")) {
		return LANG_DE;
	}

	return LANG_SK;
}

export function file(path) {
	return import.meta.env.VITE_APP_SERVER_URL + "/files" + path;
}

export function image(path, width, height, fit) {
	const url = import.meta.env.VITE_APP_SERVER_URL + "/images" + path;

	const searchParams = new URLSearchParams();
	if (width) searchParams.set("width", width);
	if (height) searchParams.set("height", height);
	if (fit) searchParams.set("fit", fit);

	if (!width && !height && !fit) {
		searchParams.set("format", "webp");
	}

	return url + "?" + searchParams.toString();
}

export function chooseText(count, text0, text1, textMore) {
	return count === 0
		? text0
		: count === 1
			? text1
			: count < 6
				? textMore
				: text0;
}

export function randomItem(arr) {
	return arr[Math.floor(Math.random() * arr.length)];
}

export function isYoutubeVideo(src) {
	return /youtube\.com\/(shorts\/|watch\?v=)([\w-]+)/.test(src);
}

const parseDate = (date) => {
	return typeof date === "string" && /^\d+$/.test(date)
		? new Date(Number(date))
		: new Date(date);
};

const FORMAT_DATE_OPTIONS = {
	day: "2-digit",
	month: "2-digit",
	year: "numeric",
};

const FORMAT_TIME_OPTIONS = {
	hour: "2-digit",
	minute: "2-digit",
	second: "2-digit",
};

export function formatDate(date) {
	const parsedDate = parseDate(date);

	if (Number.isNaN(parsedDate.getTime())) {
		return "";
	}

	return parsedDate.toLocaleDateString("sk-SK", FORMAT_DATE_OPTIONS);
}

export function formatDateTime(date) {
	const parsedDate = parseDate(date);

	if (Number.isNaN(parsedDate.getTime())) {
		return "";
	}

	return parsedDate.toLocaleDateString("sk-SK", {
		...FORMAT_DATE_OPTIONS,
		...FORMAT_TIME_OPTIONS,
	});
}

export function getCategoryTree(category, context) {
	const categories = [category];
	let parent = category.parent;
	while (parent) {
		categories.push(context.state.categoriesById[parent]);
		parent = context.state.categoriesById[parent].parent;
	}
	categories.reverse();
	return categories;
}

export function categoriesForCheckboxTree(categories) {
	const buildTree = (root, categories) => {
		for (let i = 0; i < categories.length; i++) {
			const c = categories[i];
			const children = [];
			root.push({
				value: c.id,
				label: c.name,
				children: c.children.length > 0 ? children : null,
			});

			if (c.children.length > 0) {
				buildTree(children, c.children);
			}
		}
	};

	const tree = [];
	buildTree(tree, categories);
	return tree;
}

export function addCategoriesBreadcrumbs(categories, breadcrumbs) {
	let prefix = "";
	categories.forEach((c, i) => {
		const section = i === 2 ? "listing" : "kategoria";
		breadcrumbs.push({ title: c.name, to: `/${section}/${prefix}${c.slug}` });
		prefix += c.slug + "/";
	});
}

export function generateString(length) {
	var result = "";
	var characters =
		"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
	var charactersLength = characters.length;
	for (var i = 0; i < length; i++) {
		result += characters.charAt(Math.floor(Math.random() * charactersLength));
	}
	return result;
}

export function flashMessage(message, type = "info", timeout = 15) {
	const id = generateString(16);
	const html = document.createElement("div");
	html.id = "flash-" + id;
	html.className = "flash flash-" + type;
	html.appendChild(document.createTextNode(message));
	document.body.append(html);

	setTimeout(() => {
		document.getElementById("flash-" + id).outerHTML = "";
	}, timeout * 1000);
}

export function getCookie(name) {
	const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));

	return match ? match[2] : null;
}

export function setCookie(name, value, days) {
	const d = new Date();
	d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
	document.cookie =
		name + "=" + value + ";expires=" + d.toUTCString() + ";path=/";
}

export function getCategoriesFromPath(leafCategory, categoriesById) {
	const categories = [];
	let current = leafCategory;

	while (current) {
		categories.unshift(current);
		current = current.parent ? categoriesById[current.parent] : null;
	}

	return categories;
}
